/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { NavigateFunction, createSearchParams } from 'react-router-dom';
import { Product } from '../../../storage';
import { ProductType } from '../../ProductCard/types';
import {
  getRelativeRouteWithQueryParams,
  getRoute,
} from '../../../../../util/routing';
import { PRODUCTS_ROUTE_NAME } from '../../../products.routes';

export enum EProductLocation {
  SHOP = 'Shop',
  CART = 'Cart',
}

export interface IOpenProductDetailsNavigationState {
  category: string;
  subCategory?: string;
  isPriceNegotiable?: boolean;
  productTab: number;
  lifeCycleState: string | null;
  productType: ProductType;
  productLocation: EProductLocation;
  previousRelativeUrl: string;
}

export const openProductDetailsLink = (
  item: Product,
  isAllProduct: boolean,
  productType: ProductType,
  productLocation: EProductLocation,
  navigate: NavigateFunction,
) => {
  const params = createSearchParams({
    size: item?.sizeDescription ?? '',
    colour: item?.colourDescription ?? '',
  });

  navigate(
    {
      pathname: getRoute(PRODUCTS_ROUTE_NAME, item.masterProductId),
      search: params.toString(),
    },
    {
      state: {
        category: item.category,
        subCategory: item.subCategory,
        isPriceNegotiable: item.isPriceNegotiable,
        productTab: isAllProduct ? 1 : 0,
        lifeCycleState: item.lifeCycleState,
        productType,
        productLocation,
        previousRelativeUrl: window?.location
          ? getRelativeRouteWithQueryParams(window.location.pathname, window.location.search)
          : '',
      },
    },
  );
};
